import { emitVideoStopEvent } from "@components/video-thumbs/video-thumbs.js";
import Swiper, { Pagination, Scrollbar } from "swiper";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
// configure Swiper to use modules
Swiper.use([Pagination, Scrollbar]);

export default class VideoTestimonial {
	constructor(config) {
		this.el = config.el;
		this.testimonialEls = [];
		this.init();
	}

	init() {
		this.setTestimonialEls();
		this.setClasses();
		this.addEventListeners();
		this.setSwiper(); //FOR MOBILE VIEW
	}

	setTestimonialEls() {
		const wrappers = this.el.querySelectorAll(
			".video-testimonial__item-content"
		);

		this.testimonialEls = Array.from(wrappers).reduce(
			(acc, curr, index) => {
				const closeBtn = curr.querySelector(
					".js-video-testimonial__item-btn-close"
				);
				const hoverVideo = curr.querySelector(
					".video-testimonial__item-hover-video"
				);
				const coverImage = curr.querySelector(
					".video-testimonial__item-cover-img"
				);
				const playBtn = curr.querySelector(
					"button.video-thumbs__container"
				);
				const videoPlayer = curr.querySelector(".video-thumbs-js");

				acc.push({
					el: curr,
					closeBtn,
					hoverVideo,
					coverImage,
					playBtn,
					previewing: index === 0 || index === 3,
					playing: false,
					videoPlayer,
					index,
				});

				return acc;
			},
			[]
		);
	}

	addEventListeners() {
		this.testimonialEls.forEach((testimonial) => {
			testimonial.closeBtn.addEventListener("click", () => {
				this.closeTestimonial(testimonial);
			});

			testimonial.el.addEventListener("mouseover", (e) => {
				this.setMouseoverEvent(testimonial);
			});
			testimonial.playBtn.addEventListener("focus", () => {
				this.setMouseoverEvent(testimonial);
			});
			testimonial.videoPlayer.addEventListener("playing", () => {
				this.setPlayingTestimonial(testimonial);
			});
		});
	}

	setPlayingTestimonial(testimonial) {
		this.testimonialEls.forEach((testimonial) => {
			if (testimonial.playing) {
				testimonial.playing = false;
				this.closeTestimonial(testimonial);
			}
		});

		testimonial.playing = true;

		this.setClasses();
	}

	closeTestimonial(testimonial) {
		testimonial.playing = false;
		this.setClasses();

		const playerEl = testimonial.videoPlayer.querySelector(
			".video-tag, .videoplayer__iframe"
		);
		const videoTopImage = testimonial.videoPlayer.querySelector(
			".video-thumbs__container"
		);
		videoTopImage.classList.remove("hidden");
		playerEl.tabIndex = -1;
		emitVideoStopEvent(testimonial.videoPlayer);
	}

	setMouseoverEvent(testimonial) {
		if (testimonial.previewing) return; // hovered over the already previwing testimonial, so don't do anything.

		this.testimonialEls.forEach((testimonial) => {
			testimonial.previewing = false;
		});
		testimonial.previewing = true;

		this.setClasses();
	}

	setClasses() {
		this.testimonialEls.forEach((testimonial) => {
			if (testimonial.previewing) {
				testimonial.el.classList.add("preview");
			} else {
				testimonial.el.classList.remove("preview");
			}
			if (testimonial.playing) {
				testimonial.el.classList.remove("preview");
				testimonial.el.classList.add("playing");
			} else {
				testimonial.el.classList.remove("playing");
			}
		});
	}

	setSwiper() {
		const swiper = new Swiper(
			this.el.querySelector(".video-testimonial__swiper"),
			{
				keyboard: {
					enabled: true,
				},
				pagination: {
					el: ".video-testimonial__swiper-pagination",
					type: "fraction",
				},
				scrollbar: {
					el: ".video-testimonial__swiper-scrollbar",
					draggable: true,
					hide: false,
				},
				spaceBetween: 20,
			}
		);

		swiper.on("slideChange", (swiper) => {
			const previousSlideEl = swiper.slides[swiper.previousIndex];
			if (previousSlideEl.querySelector(".playing")) {
				// close any currently playing videos on previously shown slides
				previousSlideEl
					.querySelector(".js-video-testimonial__item-btn-close")
					.click();
			}

			// set preview=true on the current slide. skip first 3, as they're for desktop
			this.setMouseoverEvent(this.testimonialEls[swiper.activeIndex + 3]);
		});
	}
}
